import React from 'react';
import type { FaqCategory, FaqItem } from '../pages/contactUs/faqs';

export const extractTextFromNode = (node: React.ReactNode): string => {
  if (node == null) return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(extractTextFromNode).join(' ');
  if (React.isValidElement(node)) return extractTextFromNode((node.props as any)?.children);
  return '';
};

export const itemMatchesQuery = (item: FaqItem, queryLower: string): boolean => {
  if (item.question.toLowerCase().includes(queryLower)) return true;
  const answerText = extractTextFromNode(item.answer).toLowerCase();
  return answerText.includes(queryLower);
};

export const filterFaqs = (faqs: readonly FaqCategory[], query: string): FaqCategory[] => {
  const q = query.trim().toLowerCase();
  if (!q) return faqs as FaqCategory[];
  return (faqs as FaqCategory[])
    .map((cat) => ({ ...cat, items: cat.items.filter((it) => itemMatchesQuery(it, q)) }))
    .filter((cat) => cat.items.length > 0);
};


